import { Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './config/amplify';
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import Calendar from './pages/Calendar';
import Gallery from './pages/Gallery';
import Reflections from './pages/Reflections';
import Team from './pages/Team';
import Ministries from './pages/Ministries';
import History from './pages/History';
import Memorial from './pages/Memorial';
import Newsletters from './pages/Newsletters';
import MeetingNotes from './pages/MeetingNotes';
import LectioDivina from './pages/LectioDivina';
import Rcia from './pages/Rcia';
import Safeguarding from './pages/Safeguarding';
import Admin from './pages/Admin';
import AuthCallback from './components/AuthCallback';

// Configure Amplify
try {
  console.log('Configuring Amplify with:', {
    region: amplifyConfig.aws_project_region,
    userPoolId: amplifyConfig.Auth?.Cognito?.userPoolId,
    userPoolClientId: amplifyConfig.Auth?.Cognito?.userPoolClientId,
    apiEndpoint: amplifyConfig.API?.REST?.allsaintsapi?.endpoint
  });

  Amplify.configure(amplifyConfig);
  console.log('✅ Amplify configured successfully');
} catch (error) {
  console.error('❌ Amplify configuration failed:', error);
  console.log('Running in demo mode');
}

function App() {
  return (
    <div className="App min-h-screen bg-church-light">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/safeguarding" element={<Safeguarding />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/reflections" element={<Reflections />} />
          <Route path="/team" element={<Team />} />
          <Route path="/ministries" element={<Ministries />} />
          <Route path="/history" element={<History />} />
          <Route path="/memorial" element={<Memorial />} />
          <Route path="/newsletters" element={<Newsletters />} />
          <Route path="/meeting-notes" element={<MeetingNotes />} />
          <Route path="/lectio-divina" element={<LectioDivina />} />
          <Route path="/rcia" element={<Rcia />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
